// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<div class="box">
  <sub-header header="'Open new account'"></sub-header>
    <div class="info info--deposit">
      <div class="info-detail">
        <span class="key">Product name:</span>
        <span class="value">{{\$ctrl.accountType.productDefinition.productName}}</span>
      </div>
      <div class="info-detail">
        <span class="key">Interest rate:</span>
        <span class="value">{{\$ctrl.accountType.interestRate | percent}}</span>
      </div>
    </div>

    <form name="\$ctrl.form">
      <validator condition="\$ctrl.hasValidOwnerConfiguration"></validator>

      <table class="misc-transaction__table table table--generate-row-ids">
        <tbody class="tbody">
        <tr>
          <td></td>
          <td>Tax exempted</td>
          <td class="values">
            <select
              ng-model="\$ctrl.account.taxExempted"
              required
              boolean-options>
            </select>
          </td>
        </tr>

        <tr>
          <td></td>
          <td>Casa class code</td>
          <td>
            <select
              required
              ng-model="\$ctrl.account.casaClassCode"
              ng-options="o.value as o.label for o in \$ctrl.casaClassCodes">
            </select>
          </td>
        </tr>

        <!-- CHECKING/COMBO accounts specific properties -->

        <tr ng-show="\$ctrl.checking">
          <td></td>
          <td>Update default ATA</td>
          <td>
            <select
              required
              ng-model="\$ctrl.account.updateAta"
              boolean-options>
            </select>
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta">
          <td></td>
          <td>ATA enabled</td>
          <td>
            <select
              required
              ng-model="\$ctrl.account.ata.enabled"
              boolean-options>
            </select>
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta && \$ctrl.account.ata.enabled">
          <td></td>
          <td>Max no of linked accounts</td>
          <td>
            <input
              required
              type="number"
              min="0"
              step="1"
              ng-model="\$ctrl.account.ata.maxRelations">
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta && \$ctrl.account.ata.enabled">
          <td></td>
          <td>Allow linking accounts of related CIFs:</td>
          <td>
            <select
              required
              ng-change="\$ctrl.resetRelations()"
              ng-model="\$ctrl.account.ata.allowExternalRelations"
              boolean-options>
            </select>
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta && \$ctrl.account.ata.enabled">
          <td></td>
          <td>Allow auto fund transfer from</td>
          <td>
            <multiselect
              ng-change="\$ctrl.resetRelations"
              items="\$ctrl.relationDefinitionsIds"
              ng-model="\$ctrl.account.ata.relationDefinitionsIds">
            </multiselect>
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta && \$ctrl.account.ata.enabled">
          <td></td>
          <td>Trigger auto fund transfer after</td>
          <td>
            <multiselect
              items="\$ctrl.triggerCommands"
              ng-model="\$ctrl.account.ata.triggerCommands">
            </multiselect>
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta && \$ctrl.account.ata.enabled">
          <td></td>
          <td>{{ \$ctrl.ataLabels.replenishmentFlag }}</td>
          <td class="values">
            <select
              required
              ng-model="\$ctrl.account.ata.replenishEnabled"
              ng-change="\$ctrl.replenishUpdated()"
              boolean-options>
            </select>
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta && \$ctrl.account.ata.enabled && \$ctrl.account.ata.replenishEnabled">
          <td></td>
          <td>{{ \$ctrl.ataLabels.replenishmentStrategy }}</td>
          <td class="values">
            <select
              ng-required="\$ctr.account.ata.replenishEnabled"
              ng-model="\$ctrl.account.ata.replenishStrategy"
              ng-options="entry.value as entry.label for entry in \$ctrl.ataEnabledReplenishStrategies">
            </select>
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta && \$ctrl.account.ata.enabled && \$ctrl.account.ata.replenishEnabled">
          <td></td>
          <td>{{ \$ctrl.ataLabels.replenishmentThreshold }}</td>
          <td>
            <cash
              ng-required="\$ctrl.account.ata.replenishEnabled"
              ng-model="\$ctrl.account.ata.replenishThreshold"
              ng-disabled="!\$ctrl.account.ata.replenishEnabled"
              min="0"></cash>
          </td>
        </tr>

        <tr ng-show="\$ctrl.account.updateAta && \$ctrl.account.ata.enabled">
          <td></td>
          <td>Allowed credit operations</td>
          <td>
            <multiselect
              items="\$ctrl.creditCommands"
              ng-model="\$ctrl.account.ata.creditCommands">
            </multiselect>
          </td>
        </tr>

        <tr>
          <td></td>
          <td>PDIC type</td>
          <td class="values">
            <select
              ng-model="\$ctrl.account.pdicTypeId"
              ng-change="\$ctrl.pdicCasaTypesChanged()"
              required
              ng-options="o.id as o.name for o in \$ctrl.pdicCasaTypes">
            </select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.checkIfCorporate()">
          <td></td>
          <td>Signatories:</td>
          <td class="values">
            <multiselect
                         items="\$ctrl.signatoryRelatives"
                         ng-model="\$ctrl.account.signatoryIds"
                         label-property="'effectiveName'"
                         value-property="'id'">
            </multiselect>
          </td>
        </tr>
        <tr ng-if="\$ctrl.accountType.allowCenterManagement">
          <td></td>
          <td>Collector</td>
          <td>
            <user-select
              hide-role="true"
              empty-option="true"
              ng-model="\$ctrl.account.collectorId"
              ng-change="\$ctrl.updateCenters()"
              users="\$ctrl.collectors">
            </user-select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.accountType.allowCenterManagement">
          <td></td>
          <td>Officer</td>
          <td>
            <user-select
              hide-role="true"
              empty-option="true"
              ng-model="\$ctrl.account.officerId"
              ng-change="\$ctrl.updateCenters()"
              users="\$ctrl.officers">
            </user-select>
          </td>
        </tr>
        <tr ng-if="\$ctrl.availableCenters.length !== 0">
          <td></td>
          <td>Center:</td>
          <td>
            <selectize options="\$ctrl.availableCenters"
                       config="\$ctrl.centerConfig"
                       ng-model="\$ctrl.account.centerId">
            </selectize>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Signature card:</td>
          <td class="values">
            <file-upload
              ng-model="\$ctrl.signatureCardFiles"
              validate-uploaded
              name="documentUpload"
              enable-webcam="false"
              show-remarks="true"
              show-file-name="true"
              max-files="1"
              allow-duplicates="false"
            ></file-upload>
          </td>
        </tr>
        </tbody>
      </table>

      <custom-field-input
        group="'ACCOUNT'"
        available-custom-fields="\$ctrl.accountType.productDefinition.customFieldDefinitionIds"
        assigned-category-ids="\$ctrl.account.categoryIds"
        custom-field-values="\$ctrl.account.customFieldValues"
        edit-mode="true"
        customer-id="\$ctrl.customerId">
      </custom-field-input>

      <!-- ATA relations-->

      <div id="ata-relations" ng-show="\$ctrl.account.ata.enabled">

        <div class="alert" ng-show="!\$ctrl.multiselectRelations || \$ctrl.multiselectRelations.length === 0">
          There are no accounts that can be used as ATA relations.
        </div>

        <div class="clearfix"></div>

        <div class="ata-relation-boxes" ng-show="\$ctrl.multiselectRelations && \$ctrl.multiselectRelations.length > 0">

          <div class="ata-relation-box form-section">
            <h2 class="section-header">Target ATA relations</h2>
            <multiselect
              items="\$ctrl.multiselectRelations"
              ng-model="\$ctrl.account.ataRelationsIds">
            </multiselect>
          </div>

          <div class="ata-relation-box" ng-if="\$ctrl.account.ataRelationsIds.length > 0">
            <h2 class="section-header">Target ATA relations order</h2>
            <ul class="ata-listing" dragula='"relationsHierarchy"' dragula-model="\$ctrl.account.ataRelationsIds">
              <li ng-repeat="id in \$ctrl.account.ataRelationsIds" class="dragula-loans">
                {{\$ctrl.accountLabel(id)}}
              </li>
            </ul>
          </div>

        </div>

      </div>

      <div ng-if="\$ctrl.multipleAccountOwnershipEnabled">
        <h2 class="section-header">Account owners</h2>
        <product-owners ownership="\$ctrl.account.ownership" edit-mode="true">
        </product-owners>
      </div>

      <ada-auto-configuration-preview
        view="'ACCOUNT'"
        customer-id="\$ctrl.customerId"
        definition-id="\$ctrl.accountType.productDefinition.id"
        condition-text="'After account activation'">
      </ada-auto-configuration-preview>

      <div class="clearfix"></div>

      <div class="buttons">
        <button type="button" class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
        <button class="btn btn-primary" ng-click="\$ctrl.open()" ng-disabled="\$ctrl.form.\$invalid">Open</button>
      </div>

    </form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/accounts/new-account/new-account-details.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;